import type { ReactNode } from "react";
import { Button } from "@akin2unde/flowui-react";
import { useWarehouse } from "./WarehouseContext";
export default function WarehouseGate({ children }: { children: ReactNode }) {
  const { Warehouse, Warehouses, Loading, Error, Reload } = useWarehouse();
  if (Loading) return <p role="status">Loading your operating warehouse…</p>;
  if (Error)
    return (
      <section>
        <h1>Warehouse access unavailable</h1>
        <p role="alert">{Error}</p>
        <Button onClick={Reload}>Retry</Button>
      </section>
    );
  if (!Warehouse)
    return (
      <section>
        <h1>Select your operating warehouse</h1>
        <p>
          {Warehouses.length
            ? "Choose a warehouse using the selector above to continue."
            : "No active warehouse is assigned to your account. Ask an administrator to assign one on the Users screen."}
        </p>
        <Button variant="outline" onClick={Reload}>
          Refresh warehouse access
        </Button>
      </section>
    );
  return <div key={Warehouse.Code}>{children}</div>;
}
